
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Toulon dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Toulon certifiée Google Partner, accompagne les entreprises toulonnaises pour accroître leur visibilité en ligne et séduire plus de clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Toulon dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Toulon certifiée Google Partner, accompagne les entreprises toulonnaises pour accroître leur visibilité en ligne et séduire plus de clients.",
        },
      ],
    };
  },
};
